import React from "react";
import SearchField from "../SearchField/SearchField";
import USPositionFormGroup from "./USPositionFormGroup";
import useUSPosition from "../../hooks/useUSPosition";
import useUSUndo from "../../hooks/useUSUndo";
import useAuth from "../../hooks/useAuth";
import { handleInputSelect, addEdits } from "./utils/inputhandlers";

const PositionsUSAInCharge = ({ clearfield }) => {
  // Load context values
  const { auth } = useAuth();
  const { USposition, setUSposition, setUSpositionData } = useUSPosition();
  const { positionEdits, editID, setEditID, undoList } = useUSUndo();

  // Local function to allow shorthand input property for onItemSelect
  const localHandleInputSelect = (item, origin, destination) => {
    handleInputSelect(
      item,
      positionEdits,
      editID,
      setEditID,
      setUSposition,
      setUSpositionData,
      addEdits,
      undoList,
      origin,
      destination
    );
  };

  return (
    <fieldset>
      <legend>In Charge:</legend>
      <div className='form-group'>
        <label>Trader:</label>
        {auth?.role === 2020 ? (
          <SearchField
            required={true}
            searchURL='/api/users/gettraderlist'
            value={USposition?.trader || ""}
            valueName='trader'
            valueID='traderID'
            style={{ width: "90%" }}
            customplaceholder='Select TIC'
            onItemSelect={(item) => {
              localHandleInputSelect(item, "trader", "trader");
            }}
            clearfield={clearfield}
          />
        ) : (
          <USPositionFormGroup readOnly={true} labelname={"Trader"} inputname={"trader"} />
        )}
      </div>
      <div className='form-group'>
        <label>Traffic:</label>
        <SearchField
          required={true}
          searchURL='/api/users/gettrafficlist'
          value={USposition?.traffic || ""}
          valueName='traffic'
          valueID='trafficID'
          style={{ width: "90%" }}
          customplaceholder='Select Traffic'
          onItemSelect={(item) => {
            localHandleInputSelect(item, "traffic", "traffic");
          }}
          clearfield={clearfield}
        />
      </div>
    </fieldset>
  );
};

export default PositionsUSAInCharge;
